import { LocalizationProvider } from '@mui/x-date-pickers';
import { captureException, captureMessage } from '@sentry/react';
import React, { useState, useEffect, forwardRef, useCallback, useContext } from 'react';
import moment from 'moment';
import { useToasts } from 'react-toast-notifications';
import DatePicker from 'react-datepicker';
import InputBordered from '../../common/InputBordered';
import { scrollToBottom, splitTime } from '../../utils/helper';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import './broadcast-filter.scss';
import DecimalInput from '../../common/DecimalInput';
import useDidMountEffect from '../../utils/useDidMountEffect';
import PAlert from '../../common/PAlert';
import Spinner from 'react-bootstrap/Spinner';
import { MessageContext } from './MessageContext';
import { Chip, Divider, IconButton, Radio, Skeleton } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { connect, useDispatch } from 'react-redux';
import { resetMessageUserListsFilter, setMessageUserListsFilter } from '../../../redux/actions/message';
import { setAlert } from '../../../redux/actions';
import { useHistory, useLocation } from 'react-router';
import Exclude from './Exclude';

/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';


const tabs = [
    {
        label: 'All Subscribers',
        key: 'all_send',
    },
    {
        label: 'Active Subscribers',
        key: 'active',
    },
    {
        label: 'New Subscribers',
        key: 'new',
    },
    {
        label: 'Subscriber Range',
        key: 'subs_range',
    },
    {
        label: 'Unsubscribed',
        key: 'unsubscribed',
    },
    {
        label: 'Favourites',
        key: 'favourites',
    },
    {
        label: 'Online',
        key: 'online',
    },
    {
        label: 'User Lists',
        key: 'user_lists',
    },
];

const CustomDatePicker = forwardRef(({ value, onClick }, ref) => (
    <button
        onClick={onClick}
        ref={ref}
        className="custom-datepicker"
    >
        {value}
    </button>
));

const BroadcastFilter = ({
    messageUserListsFilterRdx,
    setSelectedFilter,
    selectedFilter,
    setNewMsgStep,
    setUserCount,
    setNewMsgSendSelected,
    newMsgSendSelected,
    setRangeIdFromParent,
    setRangeIdToParent,
    setLastSubsParent,
    setPastHoursParent,
    setRangeDateFromParent,
    setRangeDateToParent,
    excluded,
    setExcluded,
    excludeList,
    subTitle = null,
}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();

    const { sendBy, setSendBy } = useContext(MessageContext);

    const { addToast } = useToasts();

    const [activeTab, setActiveTab] = useState('');
    const [pastHours, setPastHours] = useState(24);
    const [lastSubs, setLastSubs] = useState(1);
    const [showAlert, setShowAlert] = useState(false);
    const [gettingRangeData, setGettingRangeData] = useState(false);

    const [maxFollower, setMaxFollower] = useState('');

    useEffect(() => {
        // if (messageUserListsFilterRdx && messageUserListsFilterRdx.length > 0) {
        //   setSelectedFilter('');
        // }
    }, [messageUserListsFilterRdx]);

    const debounce = (fn, delay) => {
        let timer;
        return function () {
            let context = this,
                args = arguments;
            clearTimeout(timer);
            timer = setTimeout(() => {
                fn.apply(context, args);
            }, delay);
        };
    };


    useEffect(() => {
        if (activeTab === 'new') {
            getFirstSubscriber();
            getMaxFollowers();
            getLastSubsData(lastSubs);
        }

        if (activeTab === 'subs_range') {
            getRangeData()
                .then((response) => {
                    const data = response.data;
                    setMaxFollower(data.follower_count);
                    setRangeTotal(data.follower_count);
                    if (data.follower_count > 0) {
                        const first = data.first;
                        const last = data.last;

                        if (Object.keys(first).length > 0) {
                            setFirstRange(first);
                            setLastRange(last);
                            const fromDate = moment.utc(first.subscribed_at).local(); // new Date(moment.utc(first.subscribed_at).local().format());
                            setMinDate(fromDate);
                            setRangeDateFrom(fromDate);
                            setRangeDateFromParent(fromDate);
                            setRangeIdFrom(1);
                            setRangeIdFromParent(1);
                        }
                        if (Object.keys(last).length > 0) {
                            const toDate = moment.utc(last.subscribed_at).local();
                            setRangeDateTo(toDate);
                            setRangeDateToParent(toDate);
                            setRangeIdTo(data.follower_count);
                            setRangeIdToParent(data.follower_count);
                        }
                    } else {
                        setRangeIdFromParent(0);
                        setRangeIdFrom(0);
                        setRangeIdTo(0);
                        setRangeIdToParent(0);
                    }
                    setRangeBusy(false);
                });
        }

        if (activeTab === 'user_lists') {
            getUserLists();
        }
    }, [activeTab]);

    const [firstSubscriber, setFirstSubscriber] = useState({});
    const getFirstSubscriber = () => {
        axios.get('/api/get-first-follower')
            .then(response => {
                setFirstSubscriber(response.data);
            })
            .catch(error => {
                captureMessage(error);
            });
    };

    const getMaxFollowers = () => {
        axios.get('/api/get-max-followers')
            .then(response => {
                setMaxFollower(response.data);
            })
            .catch(error => {
                captureMessage(error);
            });
    };

    const handleTabClick = (key) => {
        if (key === selectedFilter) {
            setSelectedFilter('');
        } else {
            setSelectedFilter(key);
            dispatch(resetMessageUserListsFilter());
        }
    };

    const [pastHoursError, setPastHoursError] = useState('');
    const [lastSubsError, setLastSubsError] = useState('');
    const [newSubsBusy, setNewSubsBusy] = useState(false);
    const getPastHoursData = (value) => {
        if (value == 0 || value == '') {
            return;
        }

        // const utcOffset = moment().utcOffset() / 60;
        setNewSubsBusy(true);
        axios.get(`/api/get-new-subs`, {
            params: {
                type: 'past_hours',
                past_hours: value
            }
        })
            .then(response => {
                setLastSubs(response.data.length);
                setLastSubsParent(response.data.length);
                setNewSubsBusy(false);
            })
            .catch(error => {
                setNewSubsBusy(false);
                captureMessage(error);
            });
    };

    const handlePastHoursChange = (e) => {
        let value = e.target.value ? (e.target.value) : '';
        if (value == 0 || value == '') {
            setLastSubs(0);
            setLastSubsParent(0);
            getLastSubsData(0);
            e.preventDefault();
        }

        if (value && value > 0) {
            value = value.toString().replace(/[^0-9+]/g, '');
            if (value) {
                value = parseInt(value, 10);
            }
        } else {
            e.preventDefault();
        }

        setPastHours(value);
        setPastHoursParent(value);
        getPastHoursData(value);

        if (value.length <= 0) {
            setPastHoursError(`The value cannot be blank`);
            setLastSubsError('');
            return;
        }

        if (value <= 0) {
            setPastHoursError(`Past hour value must be greater than ${value}`);
            setLastSubsError('');
            return;
        }
        const firstSubsDate = moment.utc(firstSubscriber.subscribed_at).local();
        const maxHours = moment().diff(firstSubsDate, 'hours');

        if (value > maxHours) {
            setPastHoursError(`Your first subscription was ${maxHours} hours ago`);
            setLastSubsError('');
            return;
        }

        setPastHoursError('');
    };


    const getLastSubsData = (value) => {
        if (value == '' || value == 0) {
            return;
        }

        setNewSubsBusy(true);
        axios.get(`/api/get-new-subs`, {
            params: {
                type: 'last_subs',
                last_subs: value
            }
        })
            .then(response => {
                const first = response.data.length > 0 ? response.data[response.data.length - 1] : [];
                console.log({ first });
                if (Object.keys(first).length > 0) {
                    const startTime = moment(moment.utc(first.subscribed_at).local().toDate());
                    const end = moment();
                    const hours = Math.ceil(end.diff(startTime, 'minutes') / 60);
                    // console.log({ hours })
                    setPastHours(hours);
                    setPastHoursParent(hours);
                } else {
                    setPastHours(0);
                    setPastHoursParent(0);
                }
                setNewSubsBusy(false);
            })
            .catch(error => {
                captureException(error);
                setNewSubsBusy(false);
            });
    };

    const handlelastSubsChange = (e) => {
        let value = e.target.value ? (e.target.value) : '';

        if (value) {
            value = value.toString().replace(/[^0-9+]/g, '');
            if (value) {
                value = parseInt(value, 10);

                if (value > maxFollower) {
                    setLastSubsError(`Maximum number of subscribers is ${maxFollower}`);
                    return;
                }
            }
        } else {
            e.preventDefault();
        }

        setLastSubs(value);
        setLastSubsParent(value);
        getLastSubsData(value);

        if (value.length <= 0) {
            setLastSubsError(`The value cannot be blank`);
            setPastHoursError('');
            return;
        }

        if (value <= 0) {
            setLastSubsError(`Last subs value must be greater than ${value}`);
            setPastHoursError('');
            return;
        }

        setLastSubsError('');
    };

    const getNewSubs = () => {
        axios.get('/api/fetch-latest-sub', {
            params: {
                user_filter: activeTab,
                last_hrs: pastHours,
                except: excluded.length > 0 ? excluded.map(e => e.id).join(',') : '',
                send_by: sendBy,
            }
        })
            .then(({ data }) => {
                if (data.hours_diff > 0 && data.num_followers <= 0) {
                    const timeDiff = splitTime(data.hours_diff);
                    let inWords = '';
                    if (timeDiff.days) {
                        inWords += `${timeDiff.days} day${timeDiff.days > 1 ? 's' : ''}`;
                    }
                    if (timeDiff.hours) {
                        inWords += ` ${timeDiff.hours} hour${timeDiff.hours > 1 ? 's' : ''}`;
                    }
                    if (timeDiff.minutes) {
                        inWords += ` and ${timeDiff.minutes} minute${timeDiff.minutes > 1 ? 's' : ''}`;
                    }
                    addToast(
                        `No new subscribers in last ${pastHours} hour(s). The last user subscribed ${inWords} ago`,
                        {
                            appearance: 'success',
                            autoDismiss: false,
                        }
                    );
                }

                if (data.num_followers > 0) {
                    if (lastSubs > data.num_followers || !lastSubs) {
                        setUserCount(parseInt(data.num_followers, 10) + 1);
                    } else {
                        setUserCount(parseInt(lastSubs, 10));
                    }
                    setNewMsgStep('2');
                }

                if (data.num_followers <= 0 && data.hours_diff <= 0) {
                    addToast('No followers found.', { appearance: 'success', autoDismiss: false });
                }
            }).catch((error) => {
                captureMessage(error);
                addToast('No followers found.', { appearance: 'success', autoDismiss: false });
            });
    };

    const getSubsRange = () => {
        let params = {
            user_filter: 'subs_range_id',
            range_id_from: rangeIdFrom,
            range_id_to: rangeIdTo,
            except: excluded.length > 0 ? excluded.map(e => e.id).join(',') : '',
            source: 'broadcast'
        };
        axios.get('/api/fetch-latest-sub', {
            params
        })
            .then(({ data }) => {
                // response has data
                if (data.data && data.data.length > 0) {
                    setUserCount(data.data.length);
                    setNewMsgStep('2');
                } else {
                    addToast('You have no subscribed followers for selected range.', { appearance: 'success', autoDismiss: true });
                }
            }).catch((error) => {
                captureMessage(error);
            });
    };

    const getByFilter = () => {
        axios.get('/api/fetchConvs', {
            params: {
                user_filter: activeTab,
                except: excluded.length > 0 ? excluded.map(e => e.id).join(',') : '',
                source: 'broadcast'
            }
        })
            .then(({ data }) => {
                if (data && data.data.length > 0) {
                    // setNewSubsError('');
                    const setSendList = data.data.map(i => {
                        return { name: i.other_user, id: i.other_user_id };
                    });
                    // setNewMsgSendSelected(setSendList);
                    setUserCount(data.data.length);
                    setNewMsgStep('2');
                } else {
                    addToast('You have no unsubscribed followers', { appearance: 'success', autoDismiss: true });
                    setNewMsgStep('1');
                }
            }).catch((error) => {
                captureMessage(error);
            });
    };

    const getFavourites = () => {
        axios.get('/api/fetchConvs', {
            params: {
                user_filter: activeTab,
                except: excluded.length > 0 ? excluded.map(e => e.id).join(',') : '',
                source: 'broadcast'
            }
        })
            .then(({ data }) => {
                if (data.data && data.data.length > 0) {
                    setUserCount(data.data.length);
                    const setSendList = data.data.map(i => {
                        return { name: i.other_user, id: i.other_user_id };
                    });
                    // setNewMsgSendSelected(setSendList);
                    setNewMsgStep('2');
                } else {
                    addToast('You have no favourite followers', { appearance: 'success', autoDismiss: true });
                    setNewMsgStep('1');
                }
            }).catch((error) => {
                captureMessage(error);
            });
    };

    const handleNextStep = (e) => {
        if (activeTab === 'all_send') {
            getAllSend();
        }

        if (activeTab === 'new') {
            getNewSubs();
        }

        if (activeTab === 'subs_range') {
            getSubsRange();
        }

        if (['unsubscribed', 'online', 'active'].includes(activeTab)) {
            getByFilter();
        }

        if (activeTab === 'favourites') {
            getFavourites();
        }

        if (activeTab === 'user_lists') {
            checkUserLists();
        }

        if (newMsgSendSelected.length > 0 && activeTab === '') {
            // setNewMsgSendSelected(newMsgSendSelected);
            setNewMsgStep('2');
            setUserCount(newMsgSendSelected.length);
        }
    };

    const [checking, setChecking] = useState(false);
    const checkUserLists = () => {
        setChecking(true);
        axios.get('/api/user-lists/check', {
            params: {
                list_ids: selectedUserListIds.join(',')
            }
        })
            .then(response => {
                setChecking(false);
                if (response.data.success) {
                    if (response.data.data <= 0) {
                        dispatch(setAlert({
                            show: true,
                            type: 'warning',
                            body: 'Please select a list with assigned users'
                        }));

                        return;
                    }

                    setUserCount(response.data.data);
                    setNewMsgStep('2');
                }
            })
            .catch(error => {
                setChecking(false);
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Failed to get user count'
                }));
            });
    };

    /** Range */
    const [rangeIdFrom, setRangeIdFrom] = useState('');
    const [rangeIdTo, setRangeIdTo] = useState('');
    const [rangeDateFrom, setRangeDateFrom] = useState(null);
    const [rangeDateTo, setRangeDateTo] = useState(null);
    const [rangeTotal, setRangeTotal] = useState(0);
    const [firstRange, setFirstRange] = useState({});
    const [lastRange, setLastRange] = useState({});
    const [rangeIdFromError, setRangeIdFromError] = useState('');
    const [rangeIdToError, setRangeIdToError] = useState('');
    const [rangeDateFromError, setRangeDateFromError] = useState('');
    const [rangeDateToError, setRangeDateToError] = useState('');
    const [minDate, setMinDate] = useState(moment());
    const [maxDate, setMaxDate] = useState(moment());
    const [rangeBusy, setRangeBusy] = useState(false);

    const getRangeData = async (params = {}) => {
        try {
            setRangeBusy(true);
            setGettingRangeData(true);
            const response = await axios.get('/api/get-range-data', {
                params: params
            });
            setGettingRangeData(false);
            return response;
        } catch (error) {
            setRangeBusy(false);
            console.error({ error });
            setGettingRangeData(false);
            captureException(error);
        }
    };

    const handleRangeDateToChange = (date) => {
        setRangeDateTo(date);
        setRangeDateToParent(date);
        if (date) {
            const formatFrom = rangeDateFrom;
            const formatTo = date;

            if (formatTo.isSameOrAfter(formatFrom, 'day')) {
                const params = {
                    type: 'subs_range_date',
                    from: rangeDateFrom.format(),
                    to: date.format(),
                };
                checkInput(params);
            }
        }
    };


    const checkInput = useCallback(debounce((params = {}) => {
        getRangeData(params)
            .then((response) => {
                setRangeBusy(false);
                const data = response.data;
                if (data.follower_count > 0) {
                    const first = data.first;
                    const last = data.last;

                    if (Object.keys(first).length > 0 && params.type === 'subs_range_date') {
                        setFirstRange(first);
                        setLastRange(last);

                        setRangeIdFrom(data.from_count);
                        setRangeIdTo(data.to_count);
                        setRangeIdFromParent(data.from_count);
                        setRangeIdToParent(data.to_count);
                    }

                    if (Object.keys(first).length <= 0 && params.type === 'subs_range_date') {
                        setRangeIdFrom(0);
                        setRangeIdTo(0);
                        setRangeIdFromParent(0);
                        setRangeIdToParent(0);
                    }

                    if (Object.keys(last).length > 0 && params.type === 'subs_range_id') {
                        const fromDate = moment.utc(first.subscribed_at).local();
                        setRangeDateFrom(fromDate);
                        setRangeDateFromParent(fromDate);

                        const toDate = moment.utc(last.subscribed_at).local();
                        setRangeDateTo(toDate);
                        setRangeDateToParent(toDate);
                    }
                } else {
                    setRangeIdFrom(0);
                    setRangeIdTo(0);
                    setRangeIdFromParent(0);
                    setRangeIdToParent(0);
                }
            })
            .catch(error => {
                console.error({ error });
                setRangeBusy(false);
            });
    }, 400), []);

    useDidMountEffect(() => {
        // console.log({rangeIdTo,rangeIdFrom})
        if (rangeIdFrom.length <= 0) {
            setRangeIdFromError(`The value cannot be blank`);
            return;
        }
        if (parseInt(rangeIdFrom, 10) <= 0 && !gettingRangeData) {
            setRangeIdFromError(`The value must be greater than ${rangeIdFrom}`);
            return;
        }

        if (parseInt(rangeIdTo, 10) && parseInt(rangeIdFrom) > parseInt(rangeIdTo, 10)) {
            setRangeIdFromError(`The value must be less than the value of ${rangeIdTo}`);
            return;
        }
        if (parseInt(rangeIdFrom, 10) > parseInt(rangeTotal, 10)) {
            setRangeIdFromError(`The value must be less than the total number of subscribers ${rangeTotal}`);
            return;
        }
        setRangeIdFromError('');
    }, [rangeIdFrom]);

    useDidMountEffect(() => {
        if (rangeIdTo.length <= 0) {
            setRangeIdToError(`The value cannot be blank`);
            return;
        }
        if (parseInt(rangeIdTo, 10) <= 0 && !gettingRangeData) {
            setRangeIdToError(`The value must be greater than ${rangeIdFrom}`);
            return;
        }
        if (parseInt(rangeIdFrom, 10) && parseInt(rangeIdFrom, 10) > parseInt(rangeIdTo, 10)) {
            setRangeIdToError(`The value must be more than the start value.`);
            return;
        }

        if (showAlert) {
            return;
        }
        setRangeIdToError('');
        setRangeIdFromError('');
    }, [rangeIdTo]);

    useDidMountEffect(() => {
        // DATE
        const formatFrom = moment(rangeDateFrom).format('YYYY-MM-DD');
        const formatTo = moment(rangeDateTo).format('YYYY-MM-DD');
        const latest = moment(lastRange.subscribed_at);
        if (moment(formatFrom).isAfter(formatTo, 'day')) {
            setRangeDateFromError('The start date must be less than the end date.');
            return;
        }
        if (moment(formatFrom).isAfter(latest, 'day')) {
            setRangeDateFromError('The start date must be less than before the last subscription date');
            return;
        }

        if (moment(formatTo).isSameOrAfter(formatFrom, 'day')) {
            setRangeDateToError('');
        }
        setRangeDateFromError('');
    }, [rangeDateFrom]);

    useDidMountEffect(() => {
        // DATE
        const formatFrom = moment(rangeDateFrom).format('YYYY-MM-DD');
        const formatTo = moment(rangeDateTo).format('YYYY-MM-DD');
        if (moment(formatTo).isBefore(formatFrom, 'day')) {
            setRangeDateToError('The end date must be greater than the start date');
            return;
        }

        if (moment(formatTo).isSameOrAfter(formatFrom, 'day')) {
            setRangeDateFromError('');
        }

        setRangeDateToError('');
    }, [rangeDateTo]);

    const handleRangeDateFromChange = (date) => {
        setRangeDateFrom(date);
        setRangeDateFromParent(date);
        if (date) {
            const formatFrom = date;
            const formatTo = rangeDateTo;

            if (formatTo.isSameOrAfter(formatFrom, 'day')) {
                const params = {
                    type: 'subs_range_date',
                    from: date.format(),
                    to: rangeDateTo.format(),
                };
                checkInput(params);
            }
        }
    };

    const handleRangeIdFromChange = (value) => {
        let tmpValue = value;
        if (tmpValue) {
            tmpValue = tmpValue.toString().replace(/[^0-9+]/g, '');
            if (tmpValue) {
                tmpValue = parseInt(tmpValue, 10);
            }
        }

        setRangeIdFrom(tmpValue);
        setRangeIdFromParent(tmpValue);

        if (tmpValue) {
            const params = {
                type: 'subs_range_id',
                from: tmpValue,
                to: rangeIdTo,
            };
            checkInput(params);
        }
    };


    const handleRangeIdToChange = (value) => {
        let tmpValue = value;
        if (tmpValue) {
            tmpValue = tmpValue.toString().replace(/[^0-9+]/g, '');
            if (tmpValue) {
                tmpValue = parseInt(tmpValue, 10);
            }
        }

        if (tmpValue > maxFollower) {
            setRangeIdToError(' ');
            setShowAlert(true);
        }

        setRangeIdTo(tmpValue);
        setRangeIdToParent(tmpValue);

        if (tmpValue) {
            const params = {
                type: 'subs_range_id',
                from: rangeIdFrom,
                to: tmpValue,
            };
            checkInput(params);
        }
    };

    const getAllSend = () => {
        const get_last_hrs = 999999;

        axios.get('/api/fetchConvs', {
            params: {
                user_filter: activeTab,
                last_hrs: get_last_hrs,
                exclude: 'muted,blocked',
                except: excluded.length > 0 ? excluded.map(e => e.id).join(',') : '',
                source: 'broadcast'
            }
        })
            .then(({ data }) => {
                if (data.data.length == 0) {
                    setNewMsgStep('1');
                    // setNewMsgSendSelected([]);
                    addToast('You have no followers', { appearance: 'success', autoDismiss: false });
                } else {
                    const setSendList = data.data.map(i => {
                        return { name: i.other_user, id: i.other_user_id };
                    });
                    // setNewMsgSendSelected(setSendList);
                    setUserCount(setSendList.length);
                    setNewMsgStep('2');
                }
            }).catch((error) => {
                captureMessage(error);
            });
    };

    const handleAlterClose = () => {
        setRangeIdToError('');
        setRangeIdTo(maxFollower);
    };

    useEffect(() => {
        setActiveTab(selectedFilter);
    }, [selectedFilter]);

    const handleSendBy = (e) => {
        console.log({ e });
        const value = e.target.value;
        console.log({ value });
        setSendBy(value);
    };

    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
        },
    });

    const [userLists, setUserLists] = useState([]);
    const [userListsBusy, setUserListsBusy] = useState(false);
    const [selectedUserLists, setSelectedUserLists] = useState([]);
    const [selectedUserListIds, setSelectedUserListIds] = useState([]);
    const getUserLists = async () => {
        setUserListsBusy(true);
        await axios.get('/api/user-lists', {
            params: {
                all: true,
                order: 'DESC',
                sort: 'updated_at'
            }
        })
            .then(response => {
                setUserListsBusy(false);
                setUserLists(response.data.data);
            })
            .catch(error => {
                console.error({ error });
                setUserListsBusy(false);
                setAlert({
                    show: true,
                    type: 'error',
                    body: 'Unable to fetch user lists'
                });
            });
    };

    const handleListClick = (list) => {
        let tmp = [...selectedUserLists];
        const index = tmp.findIndex(t => t.id == list.id);

        if (index >= 0) {
            tmp.splice(index, 1);
        } else {
            tmp.push(list);
        }
        setSelectedUserLists([...tmp]);
        dispatch(setMessageUserListsFilter([...tmp]));
    };

    useEffect(() => {
        setSelectedUserListIds(selectedUserLists.map(i => i.id));
    }, [selectedUserLists]);

    const goToUserLists = () => {
        history.push({
            pathname: '/user-lists',
            state: {
                backable: true,
                from: 'broadcast',
                selected: selectedUserListIds
            }
        });
    };

    useEffect(() => {
        if (userLists.length > 0) {
            if (location && location.state && location.state.selected && location.state.selected.length > 0) {
                setSelectedUserLists(userLists.filter(i => location.state.selected.includes(i.id)));
                setSelectedUserListIds(location.state.selected);
            }
        }
    }, [userLists]);

    useEffect(() => {
        if (location && location.state && location.state.from === 'user-lists') {
            setSelectedFilter('user_lists');
        }
    }, []);

    return (
        <div className="broadcast-filter" id="broadcast-filter">
            <LocalizationProvider dateAdapter={AdapterMoment}>
                {
                    !subTitle
                        ? <ul className="filters">
                            {
                                tabs.map(tab => {
                                    if (activeTab && activeTab !== tab.key) {
                                        return null;
                                    }

                                    return <li
                                        key={tab.key}
                                        className="filters__tab"
                                    >
                                        <span
                                            className={activeTab === tab.key ? 'active' : ''}
                                            onClick={() => handleTabClick(tab.key)}
                                        >{tab.label}</span>
                                    </li>;
                                })
                            }
                        </ul>
                        : null
                }

                <div className="filters__forms">
                    {
                        activeTab === 'new' && <div className="text-center">
                            <InputBordered
                                label="Past Hours"
                                value={pastHours}
                                inputMode="numeric"
                                style={{ width: '100px' }}
                                containerClass={`mx-2${pastHoursError ? ' has-error' : ''}`}
                                onChange={handlePastHoursChange}
                                onKeyDown={(evt) => ['e', 'E', '+', '-', '.'].includes(evt.key) && evt.preventDefault()}
                            />
                            {' '}
                            Or
                            {' '}
                            <InputBordered
                                label="Last Subs"
                                value={lastSubs}
                                inputMode="numeric"
                                style={{ width: '100px' }}
                                containerClass={`mx-2${lastSubsError ? ' has-error' : ''}`}
                                onChange={handlelastSubsChange}
                                onKeyDown={(evt) => ['e', 'E', '+', '-', '.'].includes(evt.key) && evt.preventDefault()}
                            />

                            {(pastHoursError || lastSubsError) && <div style={{ margin: '0 0 10px !important', fontSize: '14px', color: '#ff0000' }}>
                                {pastHoursError || lastSubsError}
                            </div>}

                            <div className='my-1 text-center' style={{ height: 20 }}>
                                {newSubsBusy && <Spinner size="sm" animation='border' variant="primary" />}
                            </div>
                        </div>
                    }

                    {
                        activeTab === 'subs_range' && <div className="text-center px-3">
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <div>
                                    <Radio
                                        checked={sendBy === 'sub_id'}
                                        onChange={handleSendBy}
                                        value="sub_id"
                                        name="radio-buttons"
                                        inputProps={{ 'aria-label': 'Sub ID' }}
                                    />
                                </div>
                                <div className="filters__form-id">
                                    <label>Subscriber #</label>
                                    <DecimalInput
                                        disabled={sendBy !== 'sub_id'}
                                        inputMode='numeric'
                                        name="range_id_1"
                                        id="last_subs"
                                        value={rangeIdFrom}
                                        handleChange={handleRangeIdFromChange}
                                        className={rangeIdFromError ? 'has-error' : ''}
                                        bannedcharacters={['e', 'E', '+', '-', '.']}
                                    />
                                    {'  '}
                                    <span>to</span>
                                    {'  '}
                                    <DecimalInput
                                        disabled={sendBy !== 'sub_id'}
                                        inputMode='numeric'
                                        name="range_id_2"
                                        id="last_subs"
                                        value={rangeIdTo}
                                        handleChange={handleRangeIdToChange}
                                        className={rangeIdToError ? 'has-error' : ''}
                                        bannedcharacters={['e', 'E', '+', '-', '.']}
                                    />
                                    {'  '}
                                    {(rangeIdFromError || rangeIdToError) && <div style={{ margin: '0 0 10px !important', fontSize: '14px', color: '#ff0000' }}>
                                        {rangeIdFromError || rangeIdToError}
                                    </div>}
                                </div>
                            </div>

                            <div style={{ textAlign: 'center', margin: '10px auto 15px auto' }}>Or</div>

                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <div
                                    className={css`
                                        flex-float: right;
                                    `}
                                >
                                    <Radio
                                        checked={sendBy === 'date'}
                                        onChange={handleSendBy}
                                        value="date"
                                        name="radio-buttons"
                                        inputProps={{ 'aria-label': 'Date' }}
                                    />
                                </div>
                                <div className="filters__form-dates">
                                    <label>Subscription Dates</label>
                                    <div className={`range-date${rangeDateFromError ? ' has-error' : ''}`}>
                                        <MobileDatePicker
                                            defaultValue={moment()}
                                            className={`range-date${rangeDateFromError ? ' has-error' : ''}`}
                                            id="last_subs"
                                            maxDate={moment()}
                                            minDate={minDate}
                                            onChange={(date) => handleRangeDateFromChange(date)}
                                            value={rangeDateFrom}
                                            format="DD MMM YYYY"
                                            disabled={sendBy !== 'date'}
                                            theme={darkTheme}
                                        />
                                    </div>
                                    {'  '}
                                    <span>to</span>
                                    {'  '}
                                    <div className={`range-date${rangeDateToError ? ' has-error' : ''}`}>
                                        <MobileDatePicker
                                            defaultValue={moment()}
                                            className={`range-date${rangeDateToError ? ' has-error' : ''}`}
                                            id="last_subs"
                                            maxDate={moment()}
                                            minDate={rangeDateFrom}
                                            onChange={(date) => handleRangeDateToChange(date)}
                                            value={rangeDateTo}
                                            format="DD MMM YYYY"
                                            disabled={sendBy !== 'date'}
                                            theme={darkTheme}
                                        />
                                    </div>
                                    {(rangeDateFromError || rangeDateToError) && <div style={{ margin: '0 0 10px !important', fontSize: '14px', color: '#ff0000' }}>
                                        {rangeDateFromError || rangeDateToError}
                                    </div>}
                                </div>
                            </div>


                            <div className='my-1 text-center' style={{ height: 20 }}>
                                {rangeBusy && <Spinner size="sm" animation="border" variant="primary" />}
                            </div>
                        </div>
                    }
                </div>

                {
                    activeTab === 'user_lists'
                        ? <div className='user-lists-filter__lists' style={{ padding: '0 15px' }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                flex: 1
                            }}>
                                {/* <div><strong>User Lists</strong></div> */}
                                <div>
                                    <IconButton
                                        size="small"
                                        aria-label="close"
                                        color="inherit"
                                        onClick={goToUserLists}
                                    >
                                        <i className="fa-sharp fa-solid fa-pen-to-square icon"></i>
                                    </IconButton>
                                </div>

                            </div>

                            <div
                                className='user-lists__chips'
                            >
                                {
                                    userLists.map((list) => {
                                        return <Chip
                                            key={list.id}
                                            label={`${list.name} ${list.members_count > 0 ? list.members_count : ''}`}
                                            onClick={() => handleListClick(list)}
                                            color={`${selectedUserListIds.includes(list.id) ? 'primary' : 'default'}`}
                                            sx={{ margin: '0 5px 5px 0' }}
                                        />;
                                    })
                                }


                                {
                                    userLists.length === 0 && !userListsBusy
                                        ? <div>
                                            No User Lists found. Click here to create a <a style={{ color: '#0097fe' }} onClick={goToUserLists}>list</a>
                                        </div>
                                        : null
                                }
                            </div>

                            {
                                userListsBusy && userLists.length === 0
                                    ? <div>
                                        <div style={{ display: 'flex', gap: '8px', flex: 1 }}>
                                            <Skeleton animation='wave' style={{ width: '40px' }} />
                                            <Skeleton animation='wave' style={{ width: '50px' }} />
                                            <Skeleton animation='wave' style={{ width: '60px' }} />
                                            <Skeleton animation='wave' style={{ width: '50px' }} />
                                            <Skeleton animation='wave' style={{ width: '30px' }} />
                                        </div>
                                    </div>
                                    : ''
                            }
                        </div>
                        : null
                }

                {
                    activeTab
                        ? <Divider sx={{ margin: '20px auto' }} />
                        : null
                }

                {
                    activeTab
                        ? <div
                            css={css`
                            margin: 15px auto 40px auto;
                            width: 100%;

                            @media (min-width: 900px) {
                                width: 80%;
                            }
                        `}
                        >
                            <Exclude
                                sus={excludeList}
                                excluded={excluded}
                                setExcluded={setExcluded}
                            />
                        </div>
                        : null
                }

                {
                    (activeTab !== '' || (newMsgSendSelected && newMsgSendSelected.length > 0)) && <div className="filters__actions">
                        {
                            (rangeIdFromError || rangeIdToError || rangeDateFromError || rangeDateToError)
                                ? <button
                                    className="btn btn-primary btn-theme"
                                >Next</button>
                                : <button
                                    className="btn btn-primary btn-theme"
                                    onClick={handleNextStep}
                                >Next</button>
                        }
                    </div>
                }

                {
                    activeTab
                        ? <Divider sx={{ margin: '20px auto' }} />
                        : null
                }


                {
                    activeTab === 'new' && <div className="filters__information">
                        <p>
                            Send a mass message to your new subscribers. <br />
                            Select the number of new subscribers based on either:
                        </p>

                        <p>
                            1) How many hours ago they subscribed
                            <br />
                            Or<br />
                            2) The number of recent subscribers e.g. the last 10 subscribers (if you enter a value of 10)
                        </p>
                        <p>
                            Note: Enter a value in one of the boxes only, the value in the other box will automatically adjust accordingly.
                        </p>
                    </div>
                }

                {
                    activeTab === 'subs_range'
                        ? <div className="filters__information">
                            <p>Send a mass message to a group of subscribers based on when they subscribed to you so can easily send multiple mass messages to the same group of subscribers:</p>

                            <p>
                                1) Select the group of subscribers based on the date range they subscribed between e.g. send message to all subscribers who subscribed from June 1 to June 10
                                <br />
                                Or
                                <br />
                                2) Select the group of subscribers based on the order they subscribed e.g. send message to all subscribers from your 5th subscriber up to your 10th subscriber
                            </p>
                        </div>
                        : null
                }

                {
                    activeTab
                        ? <div
                            className="filters__information"
                            style={{ marginTop: '15px' }}
                        >
                            <p>*Messages to multiple recipients will be sent individually i.e. NO group chat</p>
                        </div>
                        : null
                }

                <PAlert
                    show={showAlert}
                    setShow={setShowAlert}
                    body={`The maximum amount of subscribers you can message is ${maxFollower}. You entered a value of ${rangeIdTo}.`}
                    onClose={handleAlterClose}
                />

            </LocalizationProvider>
        </div >
    );
};

const mapStateToProps = state => ({
    messageUserListsFilterRdx: state.message.userListsFilter
});

export default connect(mapStateToProps)(BroadcastFilter);
